__turbopack_context__.v({
  "appear-slide-left": "BrandCarousel-module-scss-module__ENoziq__appear-slide-left",
  "bounceTwice": "BrandCarousel-module-scss-module__ENoziq__bounceTwice",
  "carousel": "BrandCarousel-module-scss-module__ENoziq__carousel",
  "fade-in-bottom": "BrandCarousel-module-scss-module__ENoziq__fade-in-bottom",
  "fade-in-left": "BrandCarousel-module-scss-module__ENoziq__fade-in-left",
  "fade-in-right": "BrandCarousel-module-scss-module__ENoziq__fade-in-right",
  "fadeIn": "BrandCarousel-module-scss-module__ENoziq__fadeIn",
  "loader": "BrandCarousel-module-scss-module__ENoziq__loader",
  "puff-in-center": "BrandCarousel-module-scss-module__ENoziq__puff-in-center",
  "puff-in-left": "BrandCarousel-module-scss-module__ENoziq__puff-in-left",
  "pulse": "BrandCarousel-module-scss-module__ENoziq__pulse",
  "pulse-contact": "BrandCarousel-module-scss-module__ENoziq__pulse-contact",
  "shake-bottom": "BrandCarousel-module-scss-module__ENoziq__shake-bottom",
  "slide-again": "BrandCarousel-module-scss-module__ENoziq__slide-again",
  "slide-in-right": "BrandCarousel-module-scss-module__ENoziq__slide-in-right",
  "stepContent-entrance": "BrandCarousel-module-scss-module__ENoziq__stepContent-entrance",
});
